import { Box } from '@mui/material';
import { useGetAllPatientExercisesByID } from '_api';
import { AddToPatientProfileHeader } from 'components/molecules';
import { CreateSelectMultipleField } from 'components/molecules/formFields';
import { AddExerciseToPatientForm } from 'components/organisms/forms';
import { noop } from 'lodash';
import React from 'react';
import { useExercise } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { AddExerciseToPatientProfileFormProps } from './types';

export const AddExerciseToPatientProfileForm = ({
  onSubmit,
  updateListOfObjects,
  updateObject,
  exerciseList,
  patientId,
}: AddExerciseToPatientProfileFormProps) => {
  const {
    availableExercisesOption,
    isLoading: isLoadingExercise,
    getExerciseById,
  } = useExercise();
  const isFetched = !isLoadingExercise;
  const { data: patientExercises } = useGetAllPatientExercisesByID({ patientId });

  const updateExerciseList = async (key: any, arg: any) => {
    updateListOfObjects(arg);
  };

  const updateExerciseEntry = async (key: any, arg: any, contentId: number) => {
    updateObject(key, arg, contentId);
  };

  const filteredExerciseOptions = () => {
    if (patientExercises) {
      const options = availableExercisesOption.filter(
        (option) =>
          !patientExercises.some(
            (patientExercise) => patientExercise.content.id === option.name,
          ),
      );
      return options.map((opt) => ({ ...opt, name: opt.name.toString() }));
    }
    return [];
  };

  const getExercise = (id: number) => {
    const exercise = getExerciseById(id);
    if (exercise)
      return (
        <AddToPatientProfileHeader
          title={exercise.title}
          imageUrl={exercise.fullImageUrl}
        />
      );
    return null;
  };

  const exerciseFormField = [
    {
      component: CreateSelectMultipleField,
      fieldKey: 'contentId',
      label: `Select exercise`,
      options: filteredExerciseOptions() || [],
      required: true,
      xs: 12,
      onAddOption: noop,
      readonly: true,
    },
  ];

  return isFetched ? (
    <Box style={{ maxHeight: '900px' }}>
      <FormBuilder
        formFields={exerciseFormField}
        onSubmit={onSubmit}
        onUpdate={updateExerciseList}
        hideSubmit={true}
      />

      {exerciseList.length > 0 &&
        exerciseList.map((exercise) => (
          <Box
            key={exercise.contentId}
            data-testid={`exercise-assignment-${exercise.contentId}`}
            sx={{ marginBottom: '20px' }}
          >
            {getExercise(exercise.contentId)}
            <AddExerciseToPatientForm
              initValue={exercise}
              onUpdate={(key: any, arg: any) =>
                updateExerciseEntry(key, arg, exercise.contentId)
              }
              onSubmit={() => {}}
              hidePatientSelect={true}
              hideSubmit={true}
            />
            <br />
          </Box>
        ))}
    </Box>
  ) : null;
};
